import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default class extends Controller {
  connect() {
    this.initializeSwiper()
  }

  initializeSwiper() {
    this.swiper = new Swiper(this.element.querySelector('.swiper'), {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 8
        },
        576: {
          slidesPerView: 3,
          spaceBetween: 12
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 16
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 16
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 16
        }
      }
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
